module.exports = __webpack_public_path__ + "img/11423942000956.607d7ba8.png";